import React, { FunctionComponent } from 'react';

import { withErrorBoundary } from '../../../../../../helpers/hocs/with-error-boundary';
import { FeedbackModal } from '../../../../../feedback';
import { ConfirmNotification } from '../../../../../notifications/confirm-notification';
import { PSNotifications } from '../../../../../notifications/ps-notifications';
import { PromozavrRuntime } from '../../../../../promozavr';

interface NotificationsProps {
    withChat?: boolean;
}

const NotificationsComponent: FunctionComponent<NotificationsProps> = ({ withChat }) => {
    return (
        <>
            {withChat ? null : <PSNotifications />}
            <ConfirmNotification />
            <FeedbackModal />
            <PromozavrRuntime />
        </>
    );
};

export const Notifications = withErrorBoundary(NotificationsComponent);
